
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import Utils from "@/utilities/Utils";
    @Component({})
    export default class EmailList extends Vue {

        @Prop({ required: true })
        value!: string;

        get emails(): Array<{ name: string; email: string }> {
            return Utils.splitDelimited(this.value).map(Utils.parseMailbox);
        }

        FormatEmail(value: { name: string; email: string }) {
            return Utils.isEmptyOrWhitespace(value.name)
                ? value.email
                : `&quot;${value.name}&quot; &lt;${value.email}&gt;`;
        }
    }
